import { cookieGetItem, cookieSetItem, cookieRemoveItem } from './cookie';

export const setLocalStorageItem = (name, content) => {
  if (!name) return;
  if (typeof content !== 'string') {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
};

export const getLocalStorageItem = (name) => {
  if (!name) return;
  return JSON.parse(window.localStorage.getItem(name));
};

export const removeLocalStorageItem = (name) => {
  if (!name) return;
  window.localStorage.removeItem(name);
};

export const setItem = (name, content) => {
  if (!name) return;
  cookieSetItem(name, content);
};

export const setItemUserInfo = (name, content) => {
  if (!name) return;
  setLocalStorageItem(name, content.myCourses || []);
  let {
    email,
    gender,
    mobile,
    passportNo,
    username,
    wechat,
    wechatNickname,
    ...s_content
  } = content;
  cookieSetItem(name, {
    ...s_content,
    myCourses: [],
  });
};

export const getItem = (name) => {
  if (!name) return;
  const content = cookieGetItem(name);
  return content;
};

export const getItemUserInfo = (name) => {
  if (!name) return;
  let content = cookieGetItem(name);
  if (content) {
    content = {
      ...content,
      email: '',
      gender: -1,
      mobile: '',
      passportNo: '',
      username: '',
      wechat: '',
      wechatNickname: '',
      myCourses: getLocalStorageItem(name),
    };
  }
  return content;
};

export const removeItem = (name) => {
  if (!name) return;
  cookieRemoveItem(name);
  //window.sessionStorage.removeItem(name);
};

export const removeItemUserInfo = (name) => {
  if (!name) return;
  cookieRemoveItem(name);
  removeLocalStorageItem(name);
};
